export enum INVOICE_ROUTES {
  GET_ALL = "/invoice",
  GET = "/invoice/",
  CREATE = "/invoice",
  UPDATE = "/invoice/",
  REMOVE = "/invoice/",
  DOWNLOAD = "/invoice/",
  GET_STATISTIC = "/invoice/statistics",
  GET_ON_HOLD = "/invoice/onhold",
  GET_LATE = "/invoice/late",
}
